<template>
  <div class="new-coproducer">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="text-semibold">Cadastrar coprodutor</h5>
      <div class="d-flex gap-2">
        <snow-button
          text="Cancelar"
          size="sm"
          variant="gray"
          @click="$router.back()"
        />
        <snow-button
          text="Salvar"
          size="sm"
          :loading="loading"
          :disabled="!isvalid"
          @click="submit"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6">
        <snow-input
          v-model="form.email"
          required
          label="E-mail do Coprodutor"
          info="O Coprodutor precisa possuir cadastro completo utilizando este e-mail."
        />
      </div>
      <div class="col-lg-6">
        <snow-select
          v-model="form.qty_months"
          required
          label="Tempo de contrato"
          :options="[
            { id: 1, name: '1 mês' },
            { id: 2, name: '2 meses' },
            { id: 3, name: '3 meses' },
            { id: 6, name: '6 meses' },
            { id: 12, name: '1 ano' },
            { id: 24, name: '2 anos' },
            { id: 120, name: '10 anos' }
          ]"
        />
      </div>
    </div>
    <h5 class="text-semibold mt-4">Porcentagem das comissões</h5>
    <snow-switch
      v-model="form.payment_recurrence"
      label="Continuar pagando comissões a Coprodutores, após o término do contrato, pelas recorrências de vendas feitas durante a vigência dele."
    />
    <snow-input
      v-model="form.tax_product"
      money
      required
      label="Porcentagem para vendas do produtor"
      :money-config="{
        decimal: ',',
        thousands: '.',
        prefix: '%',
        precision: 1
      }"
      :rules="taxValidation"
    />

    <template v-if="!form.id">
      <div class="d-flex flex-column">
        <h5 class="text-semibold">Termos de uso da Coprodução</h5>
        <h6 class="text-dark-40">
          Ao estabelecerem uma relação de Coprodução, Produtor e Coprodutor
          reconhecem e concordam com as regras e disposições, que estão
          descritas abaixo:
        </h6>
      </div>
      <coproduction-terms />
      <snow-checkbox
        id="check"
        v-model="form.accepted_terms"
        name="Li e aceito os termos e condições da coprodução."
      />
    </template>
  </div>
</template>

<script>
import { formatPercentage } from "@/functions/formatting";
import { formFields } from "@/functions/helpers";
import { lessOrEqualTo, moreThan } from "@/functions/validation";
import moment from "moment";
import CoproductionTerms from "@/components/product/coproducer/CoproductionTerms.vue";
export default {
  components: {
    CoproductionTerms
  },
  data() {
    return {
      loading: false,
      ...formFields(
        [
          "id",
          "email",
          "qty_months",
          "tax_product",
          "payment_recurrence",
          "contract_time"
        ],
        {
          accepted_terms: "",
          payment_recurrence: false,
          ...this.data
        }
      ),
      taxValidation: [
        moreThan(
          0,
          min => `A comissão deve ser maior que ${formatPercentage(min)}`
        ),
        lessOrEqualTo(
          99,
          max => `A comissão deve ser menor ou igual a ${formatPercentage(max)}`
        )
      ]
    };
  },
  computed: {
    isvalid() {
      return (
        this.form.email &&
        this.form.qty_months &&
        this.form.tax_product &&
        this.form.tax_product > 0 &&
        this.form.tax_product <= 99 &&
        !!this.form.accepted_terms
      );
    },
    productId() {
      return this.$route.params.id;
    }
  },
  methods: {
    async submit() {
      this.loading = true;

      try {
        const { payment_recurrence, tax_product, email } = this.form;
        const contract_time =
          this.form.qty_months === -1
            ? null
            : moment()
                .add(this.form.qty_months, "months")
                .format("YYYY-MM-DD");

        const { data: coproducer } = await this.$store
          .dispatch("user/postCoProducer", email)
          .catch(error => {
            this.errors = error.response.data;
          });

        await this.$store.dispatch("user/postCoProducerProduct", {
          co_producer_id: coproducer.id,
          product_id: this.productId,
          contract_time,
          payment_recurrence,
          tax_product
        });

        this.$message.success("Coprodutor cadastrado com sucesso!");
        this.$router.push({
          name: "product-coproducers",
          params: { id: this.productId }
        });
      } catch (error) {
        if (this.errors.email.length) {
          this.$message.error(this.errors.email[0]);
          return;
        } else this.$message.error("Erro ao cadastrar co-produtor.");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.new-coproducer {
  background: var(--bg-2);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
